import React from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Checkbox,
    ChoiceList
} from '@shopify/polaris';

export function TagProductsWhenTagExistsSettings(props) {

    const onRequiredTagChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.requiredTag = value;
        props.onSettingsChange(newSettings);
    }

    const onTagToAddChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagsToAdd = [value];
        props.onSettingsChange(newSettings);
    }

    const onRemoveTagsIfRequiredTagIsMissingChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.removeTagsIfRequiredTagIsMissing = value;
        props.onSettingsChange(newSettings);
    }

    const onSkipAddTagsIfAlreadyAddedChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.skipAddTagsIfAlreadyAdded = value;
        props.onSettingsChange(newSettings);
    }

    const onProductStatusesChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.productStatuses = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <TextField
                        value={props.settings.requiredTag}
                        label="Required tag"
                        placeholder="Enter tag name."
                        onChange={onRequiredTagChange}
                        error={props.settingsErrors["requiredTag"]}
                        helpText={
                            <span>
                                The tag to check for. If it exists or is added to a product the tag specified below will be added.
                            </span>
                        }
                    />
                    <TextField
                        value={props.settings.tagsToAdd.length === 0 ? "" : props.settings.tagsToAdd[0]}
                        label="Tag to add"
                        placeholder="Enter tag name."
                        onChange={onTagToAddChange}
                        error={props.settingsErrors["tagsToAdd"]}
                        helpText={
                            <span>
                                The tag to add if the required tag is found.
                            </span>
                        }
                    />
                    <Checkbox
                        label="Auto remove tags?"
                        checked={props.settings.removeTagsIfRequiredTagIsMissing}
                        onChange={onRemoveTagsIfRequiredTagIsMissingChange}
                        helpText={
                            <span>
                                Enable automatic removal of 'Tag to add' when 'Required tag' is removed or not found.
                            </span>
                        }
                    />
                    <Checkbox
                        label="Skip Adding Tags If Already Present"
                        checked={props.settings.skipAddTagsIfAlreadyAdded}
                        onChange={onSkipAddTagsIfAlreadyAddedChange}
                        helpText={
                            <span>
                                Skips to add 'Tag to add' if it already exists.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section>
                <FormLayout>
                    <ChoiceList
                        allowMultiple
                        title="Apply the rule to products with the following states:"
                        choices={[
                            {
                                label: 'Active',
                                value: 'ACTIVE',
                            },
                            {
                                label: 'Archived',
                                value: 'ARCHIVED',
                            },
                            {
                                label: 'Draft',
                                value: 'DRAFT',
                            },
                        ]}
                        selected={props.settings.productStatuses}
                        onChange={onProductStatusesChange}
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );

}